import React from 'react';
import {useForm, SubmitHandler} from 'react-hook-form';
import {database} from '../../firebase/firebase';
import {ref, set} from 'firebase/database';

interface Inputs {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
}

const FormContact = () => {
  const {register, handleSubmit, reset} = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = data => {
    const {firstName, lastName, email, message} = data;
    set(ref(database, 'contacts/' + firstName + ' ' + lastName), {
      firstName,
      lastName,
      email,
      message,
    });
    alert('Mensaje enviado');
    reset();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="overflow-hidden shadow sm:rounded-md">
          <div className="bg-white px-4 py-5 sm:p-6">
            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6 sm:col-span-3">
                <label
                  htmlFor="first-name"
                  className="block text-sm font-medium text-gray-700">
                  Nombre
                </label>
                <input
                  type="text"
                  {...register('firstName')}
                  autoComplete="given-name"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
                />
              </div>

              <div className="col-span-6 sm:col-span-3">
                <label
                  htmlFor="last-name"
                  className="block text-sm font-medium text-gray-700">
                  Apellido
                </label>
                <input
                  type="text"
                  {...register('lastName')}
                  autoComplete="family-name"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
                />
              </div>

              <div className="col-span-6 sm:col-span-4">
                <label
                  htmlFor="email-address"
                  className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="text"
                  {...register('email')}
                  autoComplete="email"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
                />
              </div>

              <div className="col-span-6 sm:col-span-7">
                <label
                  htmlFor="about"
                  className="block text-sm font-medium text-gray-700">
                  Mensaje
                </label>
                <div className="mt-1">
                  <textarea
                    {...register('message')}
                    rows={3}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
                    placeholder="Ingrese el mensaje"
                    defaultValue={''}
                  />
                </div>
                <a
                  className="mt-2 text-sm text-gray-500"
                  href="mailto:juanjacobogarcia4@gmail.com">
                  Enviar un correo a juanjacobogarcia4@gmail.com
                </a>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
            <button
              type="submit"
              className="inline-flex justify-center rounded-md border border-transparent bg-gray-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
              Enviar
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default FormContact;
